import script from "./Step3Summary.vue?vue&type=script&setup=true&lang=js"
export * from "./Step3Summary.vue?vue&type=script&setup=true&lang=js"

import "./Step3Summary.vue?vue&type=style&index=0&id=25993836&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25993836"]])

export default __exports__